import React from 'react';
import { Button } from 'ui';

const AiModalButtons = ({
  isComplete,
  jobHasFailed,
  assumeJobIsRunning,
  startAICoding,
  isLoading,
  hasCodes,
  destroyAICoding,
  isDestroying,
  stopAICoding,
  isStopping
}) => {
  return (
    <div style={{ marginBottom: '20px', marginTop: '20px', display: 'flex'}}>
      {!isComplete && !jobHasFailed &&
        <Button
          onClick={startAICoding}
          variant={assumeJobIsRunning ? 'white' : 'blue'}
          disabled={assumeJobIsRunning || isLoading || !hasCodes}
        >
          {!assumeJobIsRunning && 'Apply codes using AI'}
          {assumeJobIsRunning && 'Coding in progress...'}
        </Button>
      }

      {(isComplete || jobHasFailed) &&
        <Button
          onClick={destroyAICoding}
          disabled={isDestroying}
          variant={'white'}
        >
          Remove codes applied with AI
        </Button>
      }

      {assumeJobIsRunning && !isComplete &&
        <Button
          style={{marginLeft: '40px', marginTop:5, paddingTop: 0}}
          variant='link'
          onClick={stopAICoding}
          disabled={isStopping}
        >
          Stop Applying Codes
        </Button>
      }
    </div>
  );
};

export default AiModalButtons;
